export type Country = {
    fullName: string;
    shortName: string;
}


type CountriesNormalize = {
    value: string;
    text: string;
}

type OutputType = "shortName" | "fullName";

export const getCountriesNormalize = (countries: Country[], outputType: OutputType, priorityCode: string) => {
    const priority = countries?.filter(country => country?.shortName === priorityCode)[0]?.fullName;

    const result: CountriesNormalize[] = countries?.map(country => ({
        value: String(country[outputType]),
        text: String(country.fullName),
    })) || [];

    return result.sort((a, b) => {
        if (a.text === priority) return -1;
        if (b.text === priority) return 1;
        return a.text.localeCompare(b.text, undefined, { sensitivity: 'base', numeric: true });
    });
}